import { render, staticRenderFns } from "./VerifyMobile.vue?vue&type=template&id=70f10df8&scoped=true"
import script from "./VerifyMobile.vue?vue&type=script&lang=js"
export * from "./VerifyMobile.vue?vue&type=script&lang=js"
import style0 from "./VerifyMobile.vue?vue&type=style&index=0&id=70f10df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f10df8",
  null
  
)

export default component.exports